<mat-form-field class="width" [appearance]="appearance" (click)="onFocus()" [formGroup]="formGroup">

    <mat-label [ngClass]="{'setted': (currentContact$|async)}">
        {{currentLabel$|async}}
    </mat-label>

    <input type="text" [placeholder]=placeholder matInput [matAutocomplete]="auto" formControlName="filter" #inputField
        (keyup.enter)="setContactIfOneLeft()" />

    <span class="suffix-wrapper" matSuffix>
        <button @fade [disabled]="formGroup.disabled || !(currentContact$|async)" mat-icon-button color="warn" (click)="selectContact(null)" matTooltip='Wert leeren'>
            <mat-icon>clear</mat-icon>
        </button>
    </span>

    <mat-autocomplete #auto="matAutocomplete" #autocomplete (optionSelected)="selectContact($event)">

        <mat-option class="custom-mat-option" [value]="contact.contactpersid" *ngFor="let contact of contacts">
            {{display(contact)}}
        </mat-option>

    </mat-autocomplete>

</mat-form-field>